<template>
  <div class="iv-review iv-p-t-24 iv-p-b-40">
    <div class="iv-main-width">
      <Tab v-model="tabName" :navList="navList" @on-click="tabClick"></Tab>
      <List
        v-if="list.length > 0"
        type="review" 
        :showPage="true" 
        :total="total" 
        :current="currentPage" 
        :list="list"
        class="iv-m-t-24"
        @on-detail="toDetailPage"
        @on-page-size-change="changePageSize"
        @on-change="changePage">
      </List>
      <NoData v-if="list.length <= 0"></NoData>
    </div>
  </div>
</template>

<script>
import Tab from '@/components/tab'
import NoData from '@/components/no-data'
import List from '@/components/declare-list'
import {list} from './interface'

export default {
  data () {
    return {
      list: [],
      endState: false,
      total: 0,
      currentPage: 1,
      pageSize: 5,
      tabName: 'progress'
    }
  },
  created () {
    this.currentPage = Number(this.$route.query.currentPage) || 1
    this.userId = this.$decode(sessionStorage.getItem('userId'))
    this.initTabs()
    this.tabName = this.$route.query.tabName || 'progress'
    this.tabClick(this.tabName, 'create')
  },
  methods: {
    //列表数据
    getListData () {
      list({endState: this.endState, currentPage: this.currentPage, pageSize: this.pageSize}).then(data => {
        this.total = data.count
        const titleMap = {
          btnStartInfo: '设置打分',
          btnViewInfo: '查看设置',
          btnScore: '打分',
          btnViewScore: '查看打分',
          btnViewResult: '评审结果'
        }
        this.list = data.data.map(item => {
          const btnList = Object.keys(titleMap).map(val => ({
            label: titleMap[val],
            value: val,
            isShow: item[val]
          }))
          return {
            ...item,
            btnList
          }
        })
      })
    },
    changePage (page) {
      this.currentPage = page
      this.getListData()
    },
    changePageSize (page) {
      this.pageSize = page
      this.getListData()
    },
    //跳转打分详情页
    toDetailPage (item, val) {
      let name = 'reviewGrade', status = ''
      if (val.value == 'btnScore' || val.value == 'btnViewScore') { //打分  查看打分
        status = item.scoreState === 'PSZT02' ? 'edit' : 'see'
      } else if (val.value == 'btnViewResult') { //评审结果
        name = 'reviewResult'
        status = this.endState === true ? 'see' : ''
      } else { //设置打分  查看设置
        name = 'reviewScoring'
        status = item.btnStartInfo ? 'edit' : 'see'
      }
      this.$router.push({
        name: name,
        query: {
          type: this.$encode(status),
          reviewInfoId: this.$encode(item.reviewInfoId),
          reviewTeamId: this.$encode(item.reviewTeamId),
          businessId: this.$encode(item.businessId),
          title: this.$encode(item.reviewInfoName),
          publisher: this.$encode(item.publicUserName),
          publishOrg: this.$encode(item.initiateOrgName),
          publicState: this.$encode(item.publicState),
          businessCode: this.$encode(item.businessCode),
          bizLineCode: this.$encode(item.bizLineCode),
          currentPage: this.currentPage,
          tabName: this.tabName
        }
      })
    },
    tabClick (name, type) {
      this.endState = name === 'end'
      this.tabName = name
      if (!type) {
        this.currentPage = 1
      }
      this.getListData()
    },
    initTabs () {
      this.navList = [{
        label: '进行中',
        name: 'progress'
      }, {
        label: '已结束',
        name: 'end'
      }]
    }
  },
  components: {
    Tab,
    List,
    NoData
  }
}
</script>

<style lang="scss" scoped>
.iv-review {
  min-height: 100%;
  background-color: #fff;
}
</style>